<script setup lang="ts">
  import { computed, getCurrentInstance } from 'vue';
  import { formatDateLong } from '@/domain/reservations/reservation-time';
  import type { IReservation } from '@/interfaces/IReservation';
  import V2ReservationRow from './day/V2ReservationRow.vue';
  const props = defineProps<{
    date: string;
    reservations: IReservation[];
    now: Date;
    timeZone: string;
    toleranceMin: number;
    businessDayStartHour?: number;
    selectedId: number | null;
  }>();
  const emit = defineEmits<{
    (event: 'select', reservation: IReservation): void;
  }>();
  const proxy = getCurrentInstance()!.proxy;
  const label = computed(() =>
    formatDateLong(props.date, props.timeZone, proxy.$i18n.locale)
  );
  function select(id: number) {
    const row = props.reservations.find((value) => value.id === id);
    if (row) emit('select', row);
  }
</script>
<template>
  <section class="agenda-day">
    <h2>
      <time :datetime="date">{{ label }}</time>
    </h2>
    <V2ReservationRow
      v-for="row in reservations"
      :key="row.id"
      :reservation="row"
      :now="now"
      :time-zone="timeZone"
      :tolerance-min="toleranceMin"
      :business-day-start-hour="businessDayStartHour"
      :selected="selectedId === row.id"
      @select="select"
    />
  </section>
</template>
<style scoped lang="scss">
  .agenda-day {
    @apply tw-mb-5 tw-rounded-xl tw-border tw-border-solid tw-border-neutral-200 tw-bg-white;
    h2 {
      @apply tw-sticky tw-top-0 tw-z-10 tw-m-0 tw-rounded-t-xl tw-bg-canvas tw-px-4 tw-py-3 tw-text-sm tw-font-semibold tw-text-neutral-900;
    }
  }
</style>
